// 小屏-温湿度
<template>
  <div class="DkbSHumiture">
    <div class="HTList T">
      <div class="chart" id="nowT"></div>
      <p class="cValue">{{sData.NowMeanT}}℃</p>
      <p class="Tit">当前平均温度</p>
      <div class="li tit">
        <p class="location">温度计位置</p>
        <p class="No">温度计编号</p>
        <p class="value">读数</p>
      </div>
      <div class="list DkbScroll">
        <div class="li" v-for="(item, index) in sData.TList" :key="index">
        <p class="location">{{item.Location}}</p>
        <p class="No">{{item.No}}</p>
        <p class="value">{{item.Value}}</p>
        </div>
      </div>
    </div>
    <div class="HTList H">
      <div class="chart" id="nowH"></div>
      <p class="cValue">{{sData.NowMeanH}}%</p>
      <p class="Tit">当前平均湿度</p>
      <div class="li tit">
        <p class="location">温度计位置</p>
        <p class="No">温度计编号</p>
        <p class="value">读数</p>
      </div>
      <div class="list DkbScroll">
        <div class="li" v-for="(item, index) in sData.HList" :key="index">
        <p class="location">{{item.Location}}</p>
        <p class="No">{{item.No}}</p>
        <p class="value">{{item.Value}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { dkbApi } from "../../../../static/js/dkb/dkb.js"
  import { showToast } from "../../../../static/js/utility/utility.js"
  let echarts = require('echarts')
  let vm, Timer

  export default {
    name: 'DkbSHumiture',
    components: {
    },
    props: {
      // 父组件传来的参数
      sData: {
        type: Object,
        default: {}
      }
    },
    computed: {
    },
    data () {
      return {
      }
    },
    created () {
      vm = this
    },
    mounted() {
      // console.log('route', this.$route)
      setTimeout(() => {
        vm.drawChart()
      }, 1000)
      vm.timeRefresh()
    },
    destroyed () {
      clearInterval(Timer)
    },
    methods: {
      // 定时刷新数据
      timeRefresh () {
        Timer = setInterval(()=>{
          vm.GetHumitureInfo()
        }, 1000*1)
      },
      // 获取温湿度设备信息（小屏）
      async GetHumitureInfo () {
        let res = await dkbApi.GetHumitureInfo()
        if (res.ErrCode === 0) {
          for (const i in res.Result) {
            vm.sData[i] = res.Result[i]
          }
          vm.$nextTick(()=>{
            vm.drawChart()
          })
        } else {
          showToast(res.meta.ErrMsg)
        }
      },
      // 绘制图表
      drawChart () {
        vm.getTChart('nowT')
        vm.getHChart('nowH')
      },
      // 获取湿度仪表
      getHChart (id) {
        let myChart = echarts.init(document.getElementById(id))
        let htmlFontSize = vm.$store.state.htmlFontSize,
            dVal = id==='nowT' ? vm.sData.NowMeanT : vm.sData.NowMeanH

        let option = {
          grid: {
            left: '0',
            right: '0',
            top: 0,
            bottom: '0',
            containLabel: true
          },
          tooltip : {
            formatter: "{a} : {c}℃"
          },
          series: [
            {
              name: '仪表盘',
              type: 'gauge',
              radius: '100%',
              min: 0,
              max: 100,
              // 轴线
              axisLine: {
                lineStyle: {
                  width: (10/100)*htmlFontSize,
                  color: [[0.2, '#6cc4bd'], [0.8, '#51c1e1'], [1, '#ea5413']]
                }
              },
              // 刻度标签
              axisLabel: {
                distance: (2/100)*htmlFontSize,
                fontSize: (10/100)*htmlFontSize,
                formatter: '{value}'
              },
              // 分割线
              splitLine: {
                length: (10/100)*htmlFontSize,
                lineStyle: {
                  opacity: 0
                }
              },
              // 刻度
              axisTick: {
                splitNumber: 1,
                length: (10/100)*htmlFontSize,
                lineStyle: {
                  color: '#093053'
                }
              },
              // 指针
              pointer: {
                show: true,
                length: (43/100)*htmlFontSize,
                width: (3/100)*htmlFontSize, //指针粗细
              },
              detail: {
                show: false,
              },
              data: [{value: dVal}]
            },
          ]
        }
        myChart.setOption(option, true)
        // setInterval(function () {
        //   option.series[0].data[0].value = (Math.random() * 100).toFixed(2) - 0
          
        // },2000)
      },
      // 获取温度仪表
      getTChart (id) {
        let myChart = echarts.init(document.getElementById(id))
        let htmlFontSize = vm.$store.state.htmlFontSize
        let TArr = {
          0: 50,
          1: 40,
          2: 30,
          3: 20,
          4: 10,
          5: 0,
          6: 10,
          7: 20,
          8: 30,
          9: 40,
          10: 50
        }

        let option = {
          grid: {
            left: '0',
            right: '0',
            top: 0,
            bottom: '0',
            containLabel: true
          },
          // tooltip : {
          //   formatter: "{a} : {c}℃"
          // },
          series: [
            {
              name: '仪表盘',
              type: 'gauge',
              radius: '100%',
              min: 0,
              max: 10,
              // 轴线
              axisLine: {
                lineStyle: {
                  width: (10/100)*htmlFontSize,
                  color: [[0.2, '#6cc4bd'], [0.8, '#51c1e1'], [1, '#ea5413']]
                }
              },
              // 刻度标签
              axisLabel: {
                distance: (2/100)*htmlFontSize,
                fontSize: (10/100)*htmlFontSize,
                // formatter: '{value}'
                formatter: function (value) {
                  return TArr[value]
                }
              },
              // 分割线
              splitLine: {
                length: (10/100)*htmlFontSize,
                lineStyle: {
                  opacity: 0
                }
              },
              // 刻度
              axisTick: {
                splitNumber: 1,
                length: (10/100)*htmlFontSize,
                lineStyle: {
                  color: '#093053'
                }
              },
              // 指针
              pointer: {
                show: true,
                length: (43/100)*htmlFontSize,
                width: (3/100)*htmlFontSize, //指针粗细
              },
              detail: {
                show: false
                // formatter: function (value) {
                //   let val = value<5 ? -TArr[value] : TArr[value]
                //   return val + '℃'
                // },
                // color: '#ffffff',
                // fontSize: (30/100)*htmlFontSize,
                // fontWeight: 'lighter',
                // offsetCenter: [0, '92%'],
              },
              data: [{value: 5}]
            },
          ]
        }
        myChart.setOption(option, true)
        // setInterval(function () {
        //   option.series[0].data[0].value = (Math.random() * 100).toFixed(2) - 0
          
        // },2000)
      },
      // 屏幕变化图表自适应加载
      resizeGetChart () {
        echarts.init(document.getElementById('nowT')).resize()
        echarts.init(document.getElementById('nowH')).resize()
      },
    },
    watch: {
      // 屏幕变化，图表自适应加载
      '$store.state.isOnresize' (newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.resizeGetChart()
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.DkbSHumiture {
  width: 100%;
  height: 100%;
  padding: 0 0.52rem;
  display: flex;
  justify-content: space-between;
  .HTList {
    height: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    .chart {
      flex-shrink: 0;
      width: 1.4rem;
      height: 1.4rem;
      margin: 0 auto;
      position: relative;
    }
    .chart:before{
      content: '';
      display: block;
      width: 0.12rem;
      height: 0.12rem;
      box-sizing: border-box;
      border-radius: 50%;
      border: 0.04rem solid #51c1e1;
      background-color: #093053;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      z-index: 9;
    }
    .cValue {
      flex-shrink: 0;
      font-size: 0.3rem;
      line-height: 1;
      font-weight: lighter;
      margin-top: -0.11rem;
    }
    .Tit {
      flex-shrink: 0;
      font-size: 0.15rem;
      line-height: 0.2rem;
      margin: 0.05rem 0 0.12rem;
    }
    .li.tit {
      flex-shrink: 0;
      width: 100%;
    }
    .li {
      width: 2.15rem;
      padding-left: 0.03rem;
      font-size: 0.12rem;
      line-height: 0.21rem;
      text-align: center;
      background-color: #072c4e;
      display: flex;
      .location {
        flex-shrink: 0;
        width: 0.83rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }
      .No {
        flex-shrink: 0;
        width: 0.84rem;
      }
      .value {
        flex-shrink: 0;
        width: 0.39rem;
      }
    }
    .list {
      width: 2.31rem;
      max-height: 100%;
      overflow-x: hidden;
      overflow-y: scroll;
      .li:nth-child(odd) {
        background-color: #103b5c;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/SScreen/Humiture.vue